import classNames from 'classnames/bind';
import { IKeyAnyValue } from 'common/types';
import { IModalComponent, Modal } from 'contexts/modalFunc';
import OtherCardFareType from 'detail/otherCardFareType';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Modals: IKeyAnyValue = {
  [Modal.CARD_FARE_TYPES]: ({
    payload: {
      departureDate,
      korFareTypes,
      passengerCount,
      prevCardFareMap,
      promotions,
      selectedCardFares,
      selectedSchedules,
      closeModal,
      restoreScroll,
      setCheckCardFareOption,
      setIsMore,
    },
  }: IKeyAnyValue) => (
    <OtherCardFareType
      departureDate={departureDate}
      korFareTypes={korFareTypes}
      passengerCount={passengerCount}
      prevCardFareMap={prevCardFareMap}
      promotions={promotions}
      selectedCardFares={selectedCardFares}
      selectedSchedules={selectedSchedules}
      closeModal={closeModal}
      restoreScroll={restoreScroll}
      setCheckCardFareOption={setCheckCardFareOption}
      setIsMore={setIsMore}
    />
  ),
};

const DetailModalContainer = ({
  modalInfo: { type, payload },
}: IModalComponent) => {
  const ModalComponent = Modals[type];
  if (!ModalComponent) return null;

  return (
    <div
      className={cx('DetailModalContainer')}
      aria-modal="true"
      data-modalOnlyMobile="true"
    >
      <div className={cx('content')}>
        <ModalComponent payload={payload} />
      </div>
    </div>
  );
};

export default DetailModalContainer;
